<template>
  <div class="form-warp">
    <div class="container">
      <div class="form-box">
        <div class="result-cell">
          <svg
            width="50"
            height="50"
            viewBox="0 0 50 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="25" cy="25" r="25" fill="#367CCC" />
            <path
              d="M20.8334 30.5261L35.5469 15.7474L37.5 17.7006L20.8334 34.3672L13.086 26.6198L14.974 24.6667L20.8334 30.5261Z"
              fill="white"
            />
          </svg>
          <h3>提交成功</h3>
          <p>我们会在3个工作日内给您回复</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  created() {},
  watch: {
    $route() {}
  },
  methods: {}
};
</script>
